<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="container">
      <popup-banner-editor v-model="form"></popup-banner-editor>
      <div class="text-end">
        <sc-button :disabled="saving" variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import { getPublicImageUrl, uploadImage } from "@/god"
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"

import PopupBannerEditor from "../components/PopupBannerEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    PopupBannerEditor,
  },
  data() {
    return {
      title: "เพิ่ม Popup Banner",
      saving: false,
      form: {
        imageFile: null,
        title: "",
        publishDate: [],
        webUrl: null,
      },
    }
  },

  methods: {
    validate() {
      const { title, imageFile, publishDate } = this.form
      if (!title || !imageFile || !Array.isArray(publishDate) || publishDate.length < 2) {
        this.$message.error("กรุณากรอกข้อมูลให้ครบถ้วน")
        return false
      }
      return true
    },
    buildParams(imageUrl) {
      const { title, publishDate: [start, end], webUrl } = this.form
      const trimmedWebUrl = (webUrl ?? "").trim()
      return {
        title,
        imageUrl,
        publishDate: {
          start: start.toISO(),
          end: end.toISO(),
        },
        webUrl: trimmedWebUrl || null,
      }
    },
    async handleClickSave() {
      if (this.saving) return
      if (!this.validate()) return

      this.saving = true
      try {
        await this.createPopupBanner()
        this.$router.push({ name: "PopupBannerListPage" })
      } catch {
        this.$message.error("ไม่สามารถสร้าง Popup Banner ได้")
      } finally {
        this.saving = false
      }
    },
    async createPopupBanner() {
      const imageUrl = await this.uploadPublicImage(this.form.imageFile)
      await baanRueJaiClient.admin.communications.popupBanners.post(this.buildParams(imageUrl))
    },
    async uploadPublicImage(file) {
      const image = await uploadImage(file, file.name, "article")
      const { url } = await getPublicImageUrl(image)

      return url
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>
